/* eslint-disable no-throw-literal */
import { useState } from 'react';
import { useLoginMutation } from '../api/loginApi';
import { LoginFormData } from '../types/loginTypes';
import { LoginApiResponse } from '../../../../core/data/rtk/baseQuery';

export const useLogin = () => {
    const [loginMutation, { isLoading, error }] = useLoginMutation();
    const [passwordVisibility, setPasswordVisibility] = useState(false);

    const togglePasswordVisibility = (p0: string) => {
        setPasswordVisibility(prev => !prev);
    };

    const handleLogin = async (formData: LoginFormData) => {
        try {
            const response = await loginMutation(formData).unwrap();
            return response;
        } catch (error) {
            
            throw error as LoginApiResponse;
        }
    };

    return {
        passwordVisibility,
        togglePasswordVisibility,
        handleLogin,
        isLoading,
        error
    };
};
